import request from '@/utils/request'

/**
 * 公共接口 API
 */

//获取配置
export function conf(data) {
  return request({
    url: '/system/basic/conf',
    method: 'post',
    data
  })
}

//绑定上级  code: 邀请码
export function bindTid(data) {
  return request({
    url: '/member/personal/bind_tid',
    method: 'post',
    data
  })
}

//绑定手机号(主要用于用户微信登录且未绑定手机号时)  mobile：手机号 code: 验证码
export function bindMobile(data) {
  return request({
    url: '/member/personal/bindMobile',
    method: 'post',
    data
  })
}

//判断是否有权限（data 1有权限 0无权限）
export function studyLimit(data) {
  return request({
    url: '/course/course/study_limit',
    method: 'post',
    data
  })
}

/** 业务 TTS（POST /course/course/tts1；Cibei 优先，Azure 兜底在后端） */
export function postTts1 (data) {
  return request({
    url: '/course/course/tts1',
    method: 'post',
    data
  })
}

/**
 * 业务 TTS Edge 通道（POST /course/course/tts3；Edge 优先，Azure 兜底在后端）
 * ⚠️ 入口层不解析 JSON body，必须 form-urlencoded
 */
export function postTts3 (data = {}) {
  const body = new URLSearchParams()
  Object.entries(data || {}).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      body.append(key, String(val))
    }
  })
  return request({
    url: '/course/course/tts3',
    method: 'post',
    data: body.toString(),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/** 口语广场等流式 TTS 票据（POST /course/course/tts_ticket） */
export function postTtsTicket (data = {}) {
  return request({
    url: '/course/course/tts_ticket',
    method: 'post',
    data
  })
}

/**
 * 口语广场 Edge TTS 流式 WS 票据（POST /course/course/tts_ws_ticket）
 * 成功 data：ticket、expires_in、auth_enabled、ws_url；取票即计次（与 tts1/tts3 共用配额）
 */
export function postTtsWsTicket (data = {}) {
  return request({
    url: '/course/course/tts_ws_ticket',
    method: 'post',
    data
  })
}

/**
 * 设置显示状态（用于背景图等设置）
 */
export function setShow(data) {
  return request({
    url: '/member/personal/set_show',
    method: 'post',
    data
  })
}

//修改资料（当前登录用户）
export function changeInfo(data) {
  return request({
    url: '/member/personal/changeInfo',
    method: 'post',
    data
  })
}

//设置登录密码(用于用户登录时发现没有登录密码时，设置登录密码)
export function setCodePass(data) {
  return request({
    url: '/member/personal/setCodePass',
    method: 'post',
    data
  })
}

//修改登录密码(旧密码修改)（当前登录用户）
export function setLoginPass(data) {
  return request({
    url: '/member/personal/setLoginPass',
    method: 'post',
    data
  })
}

//修改登录密码(密码重置)（当前登录用户）
export function forgetPass(data) {
  return request({
    url: '/member/login/forgetPass',
    method: 'post',
    data
  })
}

//站内信 列表
export function messageList(data) {
  return request({
    url: '/system/announce/announce_list',
    method: 'post',
    data
  })
}

//站内信 详情
export function messageDetail(data) {
  return request({
    url: '/system/announce/announce_detail',
    method: 'post',
    data
  })
}

//反馈添加
export function feedbackAdd(data) {
  return request({
    url: '/member/personal/feedback',
    method: 'post',
    data
  })
}

//排行榜
export function rankingList(data) {
  return request({
    url: '/course/course/ranking_list',
    method: 'post',
    data
  })
}

/** vip 列表（POST /course/vip/vip_list；含 is_upgrade、diff_price 补差价升级字段） */
export function vipList(data) {
  return request({
    url: '/course/vip/vip_list',
    method: 'post',
    data
  })
}

/**
 * 荣耀合伙人进度与收益测算（POST /course/vip/glory_partner_progress，无需登录，参数: 无）
 * 返回 data: total_count、limit_quota/limit_total、progress_percent、
 * commission_rates、income_model、real_income_estimate、passive_renew_income
 * 映射见 src/utils/gloryPartnerProgress.js
 */
export function gloryPartnerProgress(data = {}) {
  return request({
    url: '/course/vip/glory_partner_progress',
    method: 'post',
    data
  })
}

// 拼团 vip 列表（字段与 vip_list 一致，另含拼团价 pt_price）
export function ptList(data) {
  return request({
    url: '/course/vip/pt_list',
    method: 'post',
    data
  })
}

// 拼团订单列表（is_self：1 我的团购，0 团购列表）
export function ptOrderList(data) {
  return request({
    url: '/course/vip/pt_order_list',
    method: 'post',
    data
  })
}

/**
 * 拼团邀请海报二维码（POST /course/vip/pt_invite_poster_qr）
 * 参数: type(pc|h5|wxmini)、page_url、pt_order、vip_id?、regcode?
 * 响应 data：url（落地链接）、qrcode（二维码图片）、regcode、pt_order
 * PC 端固定 type=pc，page_url 为 {origin}/englishLearning/vip
 */
export function getPtInvitePosterQr (data = {}) {
  return request({
    url: '/course/vip/pt_invite_poster_qr',
    method: 'post',
    data
  })
}

//创建vip订单
export function createVipOrder(data) {
  return request({
    url: '/course/vip/create_order',
    method: 'post',
    data
  })
}

//新用户领取免费会员（vip_id）
export function freeVip(data) {
  return request({
    url: '/course/vip/get_vip',
    method: 'post',
    data
  })
}

/*
  支付
  target 支付对象编号
  target_type 支付对象类型
  pay_type 支付方式wxnative:网页二维码,miniapp:小程序,deposit：余额，alipay：支付宝，wechat：微信,official：官方公众号
  money 支付金额
  tradepwd 支付密码
  说明：official 后端取 openid_wx（公众号）；miniapp 取 openid_xcx（小程序）
*/
export function pay(data) {
  return request({
    url: '/payment/pay/pay',
    method: 'post',
    data
  })
}

/** 积分扣费规则列表（POST /member/points/deduction_rules，无需登录；data 为场景数组） */
export function pointsDeductionRules(data = {}) {
  return request({
    url: '/member/points/deduction_rules',
    method: 'post',
    data
  })
}

/** 积分套餐列表（POST /member/points/package_list） */
export function pointsPackageList(data = {}) {
  return request({
    url: '/member/points/package_list',
    method: 'post',
    data
  })
}

/** 创建积分购买订单（POST /member/points/create_order，参数: package_id） */
export function createPointsOrder(data = {}) {
  return request({
    url: '/member/points/create_order',
    method: 'post',
    data
  })
}

/** 积分购买订单详情（POST /member/points/order_detail，参数: order_sn） */
export function pointsOrderDetail(data = {}) {
  return request({
    url: '/member/points/order_detail',
    method: 'post',
    data
  })
}

/** 积分购买订单列表（POST /member/points/order_list） */
export function pointsOrderList(data = {}) {
  return request({
    url: '/member/points/order_list',
    method: 'post',
    data
  })
}

//订单列表
export function orderList(data) {
  return request({
    url: '/course/vip/order_list',
    method: 'post',
    data
  })
}

//订单详情(order_sn订单号)
export function orderDetail(data) {
  return request({
    url: '/course/vip/order_detail',
    method: 'post',
    data
  })
}

//卡密列表(status -1全部 0待使用 1已使用)
export function cardList(data) {
  return request({
    url: '/member/card/card_list',
    method: 'post',
    data
  })
}

//卡密兑换(卡号card_number 密码card_password)
export function cardUseCard(data) {
  return request({
    url: '/member/card/use_card',
    method: 'post',
    data
  })
}

// 获取微信公众号授权 URL（redirect_url: 授权后回调地址）
export function getAuthUrl(data) {
  return request({
    url: '/member/login/getAuthUrl',
    method: 'post',
    data
  })
}

/**
 * 微信公众号授权 code 换/绑支付 openid（登录态）
 * POST /member/auth/authByCode — 写入 openid_wx，供 pay_type: official
 * 勿与登录用的 /member/login/authByCode 混用
 */
export function authByCode(data) {
  return request({
    url: '/member/auth/authByCode',
    method: 'post',
    data
  })
}
